import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Select from '../Forms/Fields/Select';

const styles = () => ({
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: '70%',
    paddingRight: '1rem',
  },
});

const Dropdown = ({
  label,
  value,
  onChange,
  placeholder,
  options,
  classes,
  isDisabled,
  optionLabelKey = 'label',
  name = '',
}) => {
  return (
    <Select
      optionLabelKey={optionLabelKey}
      label={label}
      classes={classes}
      className={classes.dropdownContainer}
      options={options}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
      shrinkLabel={false}
      useSelectedValue
      placeholder={placeholder}
      name={name}
    />
  );
};

Dropdown.propTypes = {
  children: PropTypes.string,
  inputRef: PropTypes.func,
  selectProps: PropTypes.object,
  innerRef: PropTypes.element,
  innerProps: PropTypes.object,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  optionLabelKey: PropTypes.string,
};

export default withStyles(styles, { withTheme: true })(Dropdown);
